import React from 'react';
import { motion } from 'framer-motion';
export function PostScripts() {
  return <section className="w-full bg-white py-12 px-4" data-id="element-257">
      <div className="max-w-[680px] mx-auto" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col gap-4" data-id="element-259">
          <div className="border-l-4 border-gray-200 pl-5 py-2" data-id="element-260">
            <p className="text-[15px] text-[#444] italic leading-relaxed" data-id="element-261">
              <span className="font-bold mr-1" data-id="element-262">P.S.</span> — "Si llegaste hasta
              aquí sin comprar, recuerda: tienes 7 días de garantía completa. El
              único riesgo real es no intentarlo."
            </p>
          </div>

          <div className="border-l-4 border-gray-200 pl-5 py-2" data-id="element-263">
            <p className="text-[15px] text-[#444] italic leading-relaxed" data-id="element-264">
              <span className="font-bold mr-1" data-id="element-265">P.P.S.</span> — "Por $6.36 USD
              estás obteniendo un sistema valuado en $152 USD. No existe ninguna
              razón lógica para no intentarlo hoy."
            </p>
          </div>

          <div className="border-l-4 border-teal/40 pl-5 py-2" data-id="element-266">
            <p className="text-[15px] text-teal italic leading-relaxed font-medium" data-id="element-267">
              <span className="font-bold mr-1" data-id="element-268">P.P.P.S.</span> — "Cada día que
              pasa sin entender tu metabolismo después de los 40 es un día más
              en que tu cuerpo trabaja en tu contra. La información no cambia.
              Tu biología sí. Actúa hoy."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}